/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IHosports4ColumnImagesData } from './hosports-4-column-images.data';
import { IHosports4ColumnImagesProps } from './hosports-4-column-images.props.autogenerated';

export interface IHosports4ColumnImagesViewProps extends IHosports4ColumnImagesProps<IHosports4ColumnImagesData> {

}

/**
 *
 * Hosports4ColumnImages component
 * @extends {React.PureComponent<IHosports4ColumnImagesProps<IHosports4ColumnImagesData>>}
 */
class Hosports4ColumnImages extends React.PureComponent<IHosports4ColumnImagesProps<IHosports4ColumnImagesData>> {
    public render(): JSX.Element | null {

        return this.props.renderView(this.props);
    }
}

export default Hosports4ColumnImages;
